var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductPlanningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62712 39.6283C13.8395 39.6283 17.2542 36.2135 17.2542 32.0011C17.2542 27.7888 13.8395 24.374 9.62712 24.374C5.41478 24.374 2 27.7888 2 32.0011C2 36.2135 5.41478 39.6283 9.62712 39.6283Z",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3722 39.6283C58.5846 39.6283 61.9994 36.2135 61.9994 32.0011C61.9994 27.7888 58.5846 24.374 54.3722 24.374C50.1599 24.374 46.7451 27.7888 46.7451 32.0011C46.7451 36.2135 50.1599 39.6283 54.3722 39.6283Z",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0011 17.2542C36.2135 17.2542 39.6283 13.8395 39.6283 9.62712C39.6283 5.41478 36.2135 2 32.0011 2C27.7888 2 24.374 5.41478 24.374 9.62712C24.374 13.8395 27.7888 17.2542 32.0011 17.2542Z",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0011 61.9994C36.2135 61.9994 39.6283 58.5846 39.6283 54.3722C39.6283 50.1599 36.2135 46.7451 32.0011 46.7451C27.7888 46.7451 24.374 50.1599 24.374 54.3722C24.374 58.5846 27.7888 61.9994 32.0011 61.9994Z",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.626 9.62598H51.8294C54.6375 9.62598 56.9141 11.9025 56.9141 14.7107V24.8057",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7464 32H17.2549",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08594 39.1924V49.2874C7.08594 52.0956 9.36251 54.3721 12.1707 54.3721H24.3741",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.626 54.374H61.9989",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.661 9.62598H2",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6621 14.7125L16.7469 9.62771L11.6621 4.54297",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9141 59.4576L61.9988 54.3728L56.9141 49.2881",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlanningIcon);
export default __webpack_public_path__ + "static/media/productPlanningIcon.aa277e854c2f507d19b09cc6f6978a93.svg";
export { ForwardRef as ReactComponent };